import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Divider, Typography, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import './css/switch.css'
import MerchatnsFilter from "../common/filters";
import CloseIcon from '@mui/icons-material/Close';
import { disableMerchant, getAllPlans } from "../../utils/firebase/firestore";
import CustomDialog from "../common/CustomDialog";
import DangerousIcon from '@mui/icons-material/Dangerous';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Spinner from "../common/spinner";
import { mainColor } from "../../constants";
export default function CustomPaginationTable({ rows, columns,setSearch,handleChange,loading }) {
    const navigate = useNavigate();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5); 
    const [choosenFilter,setChoosenFilter]=React.useState("");
    const [showFilter,setShowFilter]=React.useState(false);
    const [disableMsg,setDisableMsg]=React.useState("")
    const [filter,setFilter]=React.useState({
        [choosenFilter]:null
    })
    const [successAction,setSucessAction]=React.useState(false);
    const [selected4Action,setSelected4Action]=React.useState({
        name:null,
        action:false,
    })
    const [disableStatus,handleDisbaleStatus]=React.useState(false);
    const [enableMsg,handlEnableMsg]=React.useState(false);
    const [plans,setPlans]=React.useState([])
    const [filterOpts,setFilterOpts]=React.useState([])
    React.useEffect(()=>{
        (async()=>{
            const res=await getAllPlans();
            setPlans(["Free Trial",...res.map(p=>p.title)])
            const values={
                plan:["Free Trial",...res.map(p=>p.title)],
                planStauts:["active","cancelled"]
            }
            setFilterOpts(values)
        })()
    },[]);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleConfirmDisable=async()=>{
        const res=await disableMerchant(selected4Action.name,selected4Action.action,disableMsg);
        setSucessAction(res);
        const showMsgelemtent=document.getElementById(`${selected4Action.name}msg`)
        showMsgelemtent.style.visibility="visible"
        // handleDisbaleMsg(p=>!p);
        handleChange(s=>!s)
        setTimeout(() => {
          showMsgelemtent.style.visibility="hidden"
        }, 3000);
    }
    const handleConfirmEnable=async()=>{
        const res=await disableMerchant(selected4Action.name,selected4Action.action,"");
        setSucessAction(res);
        const showMsgelemtent=document.getElementById(`${selected4Action.name}msg`)
        showMsgelemtent.style.visibility="visible"
        setTimeout(() => {
          showMsgelemtent.style.visibility="hidden"  
        }, 3000);
        // handlEnableMsg(p=>!p);
        handleChange(s=>!s)
    }
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor:"#F3F3F7", //theme.palette.action.hover,
        color: theme.palette.common.black,
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        "&:last-child td, &:last-child th": {
        border: 0,
        },
    }));
    return (
        <Paper sx={{ width: "90%", margin: 0,position:"relative",  }}>
            <Paper
                component="form"
                sx={{ p: '2px 4px', display: 'flex',boxShadow:"none", alignItems: 'center'}}
                >
                <Box  sx={{
                        border:"1px solid #D5D6D7",
                        borderRadius:3,
                        flex:1,
                        display:"flex",
                        justifyContent:"space-between",
                        marginRight:5
                        }}>
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search Stores by name or store code "
                        inputProps={{ 'aria-label': 'search stores' }}
                        onChange={(e)=>setSearch(e.target.value)}
                    />
                    <IconButton type="button" sx={{ p: '10px',color:"#D5D6D7" }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                </Box>
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                <Box sx={{display:"flex",alignItems:"center"}}>
                    {choosenFilter&&<div style={{
                        minWidth:100,
                        padding:"0px 5px",
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems:"center",
                        backgroundColor:"lightgray",
                        // border:"1px solid ",
                        borderRadius:5,
                    }}>
                        <p>{choosenFilter}</p>
                        <IconButton onClick={()=>setChoosenFilter("")}  sx={{ color:"#000000" }}  >
                            <CloseIcon />
                        </IconButton>
                    </div>}
                    <IconButton onClick={()=>setShowFilter(s=>!s)} color="primary" sx={{ p: '10px',mr:"20px",ml:"20px",display:"flex",justifyContent:"flex-start",alignItems:"center" }} aria-label="directions">
                        <div style={{
                            border:"1px solid #D5D6D7",
                            borderRadius:8,
                            display:"flex",justifyContent:"center",alignItems:"center",
                            padding:8,
                            marginRight:5,
                            width:100,
                        }}>
                            <LinearScaleIcon  />

                        <Typography variant="body2">Filter</Typography>
                        </div>
                    </IconButton>
                </Box>
                
            </Paper>
        <TableContainer sx={{ maxHeight: 440, }}>
            <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                {columns.map((column) => (
                    <StyledTableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    
                    >
                    {column.label}
                    </StyledTableCell>
                ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .filter(r=>{
                    switch (choosenFilter) {
                        case "Free Trial":
                            return r.planName=="Free Trial"
                            break;
                        case "active":
                            return r.status=="active";
                        case "cancelled":
                            return r.status=="cancelled";
                        case "":
                            return true;
                        default:
                            return r.planName==choosenFilter
                            break;
                    }
                }).length>0?
                rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .filter(r=>{
                    switch (choosenFilter) {
                        case "Free Trial":
                            return r.planName=="Free Trial"
                            break;
                        case "active":
                            return r.status=="active";
                        case "cancelled":
                            return r.status=="cancelled";
                        case "":
                            return true;
                        default:
                            return r.planName==choosenFilter
                            break;
                    }
                })
                .map((row) => {
                    return (
                    <TableRow 
                        
                        hover 
                        role="checkbox" 
                         key={row.id}>
                            {columns.map((column) => {
                            const value = row[column.id];
                            const name=row.name
                            return (
                                column.id==="action"?<TableCell key={column.id} align={column.align}>
                                    <IconButton 
                                        onClick={() =>navigate(`/merchants/${row.name}`)}
                                        sx={{color:mainColor}}>
                                        <VisibilityIcon />
                                    </IconButton>
                                </TableCell>:
                                column.id=="status"?<TableCell  key={column.id} align={column.align}>
                                    <div style={{
                                    backgroundColor:value=="active"?"rgba(50, 147, 111, 0.16)":"#FFF2E2",
                                    width:"fit-content",
                                    padding:5,
                                    color:value!=="active"?"#AC8556":"#519C66",
                                    borderRadius:5,
                                    textAlign:'center',
                                    width:120
                                }}>
                                        <p>{ value}</p>
                                    </div>
                                
                                </TableCell>:
                                column.id!=="disabled"?<TableCell key={column.id} align={column.align}>
                                {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>:
                                <TableCell key={column.id} align={column.align}>
                                    <div style={{display:"flex",alignItems:"center",textAlign:"center"}}>
                                        
                                        <label className="switch">
                                        <input id={name+'d'} type="checkbox"  checked={!value}
                                        
                                        />
                                        <span className="slider round"
                                            onClick={async(e)=>{
                                                e.stopPropagation()
                                                // try {
                                                    const element= document.getElementById(name+'d')
                                                if(element.checked){
                                                    setSelected4Action({
                                                    name,
                                                    action:!value
                                                    })
                                                    handleDisbaleStatus(true);
                                                    
                                                }else{
                                                    setSelected4Action({
                                                    name,
                                                    action:!value
                                                    })
                                                    handlEnableMsg(true);

                                                }
                                                // } catch (e) {
                                                // console.log(e.message)
                                                // }
                                                
                                            }}
                                        ></span>
                                        </label>
                                        <div id={name+"msg"}
                                         style={{
                                            display:"flex",
                                            visibility:"hidden",
                                            alignItems:"center"
                                        }}
                                         >
                                            <IconButton sx={{color:!successAction?"red":"green"}}>
                                                {successAction?<CheckBoxIcon  />:<DangerousIcon/>}
                                            </IconButton>
                                            <p style={{color:successAction?"green":"red"}}>{successAction?"Success":"Failed"}</p>

                                        </div>
                                    </div>
                                    
                                </TableCell>
                            
                            );
                        })}
                    </TableRow>
                    );
                }):<div style={{
                    margin:10,
                    fontSize:24,
                }}>There is no match for this search</div>}
            </TableBody>
            </Table>
        </TableContainer>
            
        <TablePagination
            rowsPerPageOptions={[5]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
        {showFilter&&plans&&<MerchatnsFilter setChecked={setChoosenFilter}  plans={plans}  close={()=>setShowFilter(false)}/>}
        <CustomDialog 
            open={disableStatus}
            header={"Disable Store"}
            handleClose={()=>{
                handleDisbaleStatus(p=>!p)
                setDisableMsg("")
            }
            }
            confirm={{
                color:"#D52341",
                text:"disable Store",
                action:handleConfirmDisable
                
            }}
            text={`Are you sure that you want to disable ${selected4Action.name} Store?`}
            text1={["Disabling merchant will prevent the store from using Expert Minute."]}
            cancel={{text:"cancel"}}
            msg={{
                required:true,
                txt:"Reason for disable action",
                value:disableMsg,
                onChange:setDisableMsg
            }}
        />
        <CustomDialog 
            open={enableMsg}
            header={"Enable Store"}
            handleClose={()=>handlEnableMsg(p=>!p)}
            confirm={{
                color:"#39A956",
                text:"enable Store",
                action:handleConfirmEnable
            }}
            text={`Are you sure that you want to enable ${selected4Action.name} Store?`}
                text1={["Enabling the merchant will allow the store to use the Expert Minute application."]}
            cancel={{text:"cancel"}}
        />
        </Paper>
    );
}
